import React from 'react';

import './Footer.scss';

export default function Footer(): React.ReactElement {
  return (
    <footer>
      <a href="https://www.arduino.cc/">© {new Date().getFullYear()} Arduino</a>
      <div>
        <a href="https://www.arduino.cc/en/terms-conditions">Terms Of Service</a>
        <a href="https://www.arduino.cc/en/privacy-policy">Privacy Policy</a>
        <a href="https://www.arduino.cc/en/security">Security</a>
        <a href="https://www.arduino.cc/en/cookie-policy">Cookie Settings</a>
      </div>
      <div> </div>
    </footer>
  );
}
